import React, { JSX, useState } from 'react';
import DesktopClientDownloadsForRealm from '../components/DesktopClient/DesktopClientDownloadsForRealm';
import Modal from '../components/Modal';
import useTheme from './UseTheme';

/**
 * Custom hook for updating the user account
 */
export default function useDesktopClientModal(): {
  dialog: JSX.Element;
  openModal: () => void;
} {
  const [modalIsVisible, setModalIsVisible] = useState<boolean>(false);

  const { companyName } = useTheme();

  return {
    openModal: () => setModalIsVisible(true),
    dialog: (
      <Modal title={`Download and install ${companyName}`} isVisible={modalIsVisible} onRequestCloseModal={() => setModalIsVisible(false)}>
        <DesktopClientDownloadsForRealm />
      </Modal>
    ),
  };
}
